import { apiCall } from './generated/gqlClient';

export const getProviderRankingsApiRequest = async () => {
  const query = `
    query getProviderRankings {
      getProviderRankings {
        topProvidersByRevenue {
          id
          name
          revenue
          bookings
        }
        topProvidersByBookings {
          id
          name
          revenue
          bookings
        }
        topServicesByBookings {
          id
          name
          providerName
          bookings
        }
        topCollaboratorsByBookings {
          id
          name
          bookings
        }
        topAffiliatedCentersByRevenue {
          id
          name
          revenue
          bookings
        }
      }
    }
  `;

  return apiCall({ query });
};
